/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Alert, Collapse } from '@mui/material';
import { useTranslation } from 'react-i18next';

function OutstandingBanner({ amount, onBannerClick }) {
  const { t } = useTranslation('labels');

  return (
    <Box sx={{ width: '100%' }} id="OutstandingBannerBox">
      <Collapse in>
        <Alert sx={{ mb: 2, cursor: 'pointer' }} severity="warning" variant="filled" icon={false} onClick={onBannerClick}>
          {t('you_have_an_outstanding_balance')} {amount}. {t('click_the_banner_to_see_your_unpaid_invoices')}
        </Alert>
      </Collapse>
    </Box>
  );
}

OutstandingBanner.propTypes = {
  amount: PropTypes.string.isRequired,
  onBannerClick: PropTypes.func.isRequired,
};
export default OutstandingBanner;
